import getWallet from "./utils/getWallet";
import checkMetamask from "./utils/checkMetamask";
import { block, unblock } from './utils/blocker';
import filter from './widgets/filters/filters';
import claimTokens from './utils/claimTokens';
import claimNfsgxTokens from './utils/claimNfsgxTokens';
import initCountdown from './utils/initCountdown';
import getNfsgContract from './utils/getNfsgContract';
import getNfsgxContract from './utils/getNfsgxContract';

let search = null;
export const getSearch = () => {
  return search;
}

export const setSearch = (params) => {
  search = params;
}

let reloadDefault = 'ajax';
export const getReloadDefault = () => {
  return search;
}

export const setReloadDefault = (params) => {
  search = params;
}

function debounce(func, wait, immediate) {
  let timeout;
  return function () {
    const context = this;
    // eslint-disable-next-line prefer-rest-params
    const args = arguments;
    const later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

export const searchStringify = (params) => {
  const str = [];

  if(window.additionalFilters.length)
  {
    for(var i in window.additionalFilters)
    {
      str.push(window.additionalFilters[i]);
    }
  }

  for (const key in params) {
    if (params[key] !== '') {
      for (let i = 0; i < params[key].length; i++) {
        if (!params[key][i]) {
          const index = params[key].indexOf(params[key][i]);
          if (index > -1) {
            params[key].splice(index, 1);
          }
        }
      }
      str.push(`${key}=${params[key].join(',')}`);
    }
    if (params[key] === '') {
      delete params[key];
    }
  }
  return str.join('&');
};

export const searchParse = (data) => {
  const copy = Object.assign({}, data);
  for (const key in copy) {
    if (typeof copy[key] === 'string') { // aranan anahtar kelime bir tane varsa
      copy[key] = copy[key].split(',');
    } else if (typeof copy[key] === 'object') { // aranan anahtar kelime birden fazlaysa
      copy[key] = copy[key].join(',').split(',').filter((item, pos, self) => self.indexOf(item) === pos);
    }
  }
  for (const key in copy) {
    if (!copy[key] || !key) {
      delete copy[key];
    }
  }
  return copy;
};

export const trigerChange = debounce((reload = reloadDefault) => {
  const stringified = searchStringify(search);
  if (reload === 'reload') {
    window.location.search = stringified;
  } else if (reload === 'ajax') {
    const url = `${window.location.pathname}?${stringified}`;
    window.history.pushState({ foo: '' }, '', url);
    (async () => {
      var address = '';
      var updatedIds = [];
      var totalAvatars = '';

      const widgetId = ($('.widget_NftList').data('design-widget-id')||$('.js-reload-my-wallet').data('cms_design_widget_id'));
      let query = `info_item_id=${window.itemId}&cms_design_widget_id=${widgetId}&is_ajax=1&page_no=${window.currentPageNo}&${stringified}`;

      if(window.inMyWallet)
      {
        if (!await checkMetamask()) {
          return;
        }

        const ids = await getWallet();
        const accounts = await web3Client.eth.getAccounts();
        address = accounts[0];
        updatedIds = ids.slice(0, 1000);
        totalAvatars = ids.length;
        // query += `&ids=${updatedIds.join(',')}`
      }

      block();

      $.post(`/ajax/widget/render?`, `${query}&chainId=${window.selectedChain === 'CHZ' ? window.chainIdChz : window.chainId}`, (data) => {
        $(`.widget[data-design-widget-id="${widgetId}"]`).html(data);
        $('#avaxtar-count').text(totalAvatars);
        unblock();

        // putOnMarketplace();
        filter('ajax');
        if(window.inMyWallet)
        {
          claimTokens();
          claimNfsgxTokens();
        }

        initCountdown();
        (async () => {
          if(window.inMyWallet)
          {
            const accounts = await web3Client.eth.getAccounts();

            const nfsgContract = getNfsgContract();
            const balance = await nfsgContract.methods.balanceOf(accounts[0]).call();

            $('#on-chain-balance').text((balance / 1000000)?.toFixed(2));
            if (balance > 0) {
              $('.js-stake-tokens').show();
            } else {
              $('.js-stake-tokens').hide();
            }

            const nfsgxContract = getNfsgxContract();
            const balanceNfsgx = await nfsgxContract.methods.balanceOf(accounts[0]).call();

            $('#on-chain-balance-nfsgx').text((balanceNfsgx / 1000000)?.toFixed(2));
            if (balanceNfsgx > 0) {
              $('.js-stake-nfsgx-tokens').show();
            } else {
              $('.js-stake-nfsgx-tokens').hide();
            }
          }
        })()
      });
    })();
  }
}, 10);

export const updateSearch = ({ action, key, value, unique = false, type = 'checkbox', reload = reloadDefault }) => {
  if (typeof search[key] !== 'undefined' && !unique && type === 'checkbox') {
    if (search[key].includes(value)) {
      search[key].splice(search[key].indexOf(value), 1);
    } else {
      search[key].push(value);
    }
  } else if (value) {
    if (search[key]?.includes(value)) {
      delete search[key];
    } else {
      search[key] = [value];
    }
  } else {
    delete search[key];
  }
  for (const skey in search) {
    if (search[skey].length === 0) {
      delete search[skey];
    }
  }
  if (key !== 'p') {
    delete search['p'];
  }
  if (action === 'only') {
    for (const skey in search) {
      if (skey !== key && skey !== 'address') {
        delete search[skey];
      }
    }
  }
  trigerChange(reload);
};
